import { API_BASE } from '../config';

export interface AddressSuggestion {
  label: string;
  lat: number;
  lng: number;
}

export interface JourneyLeg {
  mode: string;
  lineName: string;
  duration: number;
}

export interface JourneyData {
  duration: number;
  legs: JourneyLeg[];
}

const NOMINATIM_BASE = 'https://nominatim.openstreetmap.org/search';

export async function autocompleteAddress(query: string): Promise<AddressSuggestion[]> {
  if (!query) return [];

  try {
    const url = `${NOMINATIM_BASE}?q=${encodeURIComponent(query)}&format=json&countrycodes=gb&viewbox=-0.489,51.28,0.236,51.686&bounded=1&limit=5`;
    const response = await fetch(url, { headers: { 'User-Agent': 'homescout-web/1.0' } });
    if (!response.ok) return [];
    const data = await response.json();
    return (data as { display_name: string; lat: string; lon: string }[]).map((item) => ({
      label: item.display_name,
      lat: parseFloat(item.lat),
      lng: parseFloat(item.lon),
    }));
  } catch {
    return [];
  }
}

export async function getReachableLocations(
  destination: { lat: number; lng: number },
  maxMinutes: number
): Promise<{ id: string; journey: JourneyData }[]> {
  const url = `${API_BASE}/api/commute/reachable?latitude=${destination.lat}&longitude=${destination.lng}&maxMinutes=${maxMinutes}`;
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Commute API error: ${response.status}`);
  const data = await response.json();
  return (data.locations as { locationId: string; durationMinutes: number; legs: JourneyLeg[] }[]).map((loc) => ({
    id: loc.locationId,
    journey: { duration: loc.durationMinutes, legs: loc.legs },
  }));
}
